import { notification } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getFundingSources } from '../services/AccountApi/paymentMethodApi';
import { resetLoginPin } from '../services/AccountApi/profileApi';
import { getAccountBalances, getAgreement, placeBuyOrder, processPlaceOrder } from '../services/InitialOfferings/initialOfferingSection';
import { cancelBuyOrderAction, fetchInitialOfferingListAction } from '../store/reducer/initialOfferingSlice';
import { fetchSecondaryOfferingListAction } from '../store/reducer/secondaryOfferingSlice';
import { toastNotify } from '../utils/toastNotify';
import { getUsCurrencyFormat, getUsPercentageFormat } from '../utils/usCurrencyFormatter';

import ListingAgreementNotification from '../components/ListingAgreement/ListingAgreementNotification';

const useQuickBuyOrder = (modalState, quickBuyPropertyData) => {
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState('');
  const [walletsData, setWalletsData] = useState([]);
  const [numberOfShare, setNumberOfShare] = useState('');
  const [resetPin, setResetPin] = useState(false);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [agreementData, setAgreementData] = useState('');
  const [orderId, setOrderId] = useState('');
  const [isScrolledBuy, setIsScrolledBuy] = useState(false);
  const [isTurmAndCondistion, setIsTurmAndCondistion] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
  const [isEditPayment, setIsEditPayment] = useState(false);
  const [userBalance, setUserBalance] = useState();

  const [isTOSModal, setIsTOSModal] = useState(false);

  const dispatch = useDispatch();

  const totalInvestment = Number(quickBuyPropertyData?.perSharePrice) * Number(numberOfShare);
  const totalPurchase = totalInvestment + 2.5;
  const equity = getUsPercentageFormat((Number(numberOfShare) / Number(quickBuyPropertyData?.totalShares)) * 100);
  let date1 = moment();
  let date2 = moment(new Date(quickBuyPropertyData?.duration));
  let daysReamaining = date2.diff(date1, 'days');
  const remainingSharesCount = (Number(quickBuyPropertyData?.totalShares) * 9.8) / 100 - Number(quickBuyPropertyData?.userPurchasedShares);
  const remainingShares = Math.floor(remainingSharesCount.toFixed(2));
  const isMaxRangeError = Number(numberOfShare) > Number(remainingShares);
  const minButtonValue =
    Number(quickBuyPropertyData?.minimum) / Number(quickBuyPropertyData?.perSharePrice) === Infinity
      ? 0
      : remainingShares < Number(quickBuyPropertyData?.minimum) / Number(quickBuyPropertyData?.perSharePrice)
      ? Math.floor(((Number(quickBuyPropertyData?.totalShares) * 9.8) / 100 - Number(quickBuyPropertyData?.userPurchasedShares)).toFixed(2))
      : Math.ceil(getUsCurrencyFormat(Number(quickBuyPropertyData?.minimum) / Number(quickBuyPropertyData?.perSharePrice)));
  const isMinRangeError = Number(numberOfShare) < Number(minButtonValue);

  const handleScrollBuy = (e) => {
    if (e.target.scrollTop > 10) setIsScrolledBuy(true);
    else setIsScrolledBuy(false);
  };

  const handleFeatchBankDetail = async (value) => {
    try {
      const userData = await getFundingSources();
      if (!userData.isError) {
        setWalletsData(userData?.data?.wallets.concat(userData?.data?.banks).concat({ id: -1, brandName: 'Add new', sourceType: 'add new' }));
        setSelectedPaymentMethod(userData?.data?.wallets?.[0]);
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleGetAccountBalances = async () => {
    try {
      const userData = await getAccountBalances();
      if (!userData.isError) {
        setUserBalance(userData?.data);
        if (selectedPaymentMethod.sourceType === 'Wallet') {
          const updatedSelectedPaymentMethod = {
            ...selectedPaymentMethod,
            balance: userData.data.cash.toString(),
          };

          setSelectedPaymentMethod(updatedSelectedPaymentMethod);
        }
        if (walletsData.length > 0) {
          const updatedWalletData = walletsData.map((item) =>
            item.brandName === 'DWOLLA' ? { ...item, balance: userData.data.cash.toString() } : item
          );
          setWalletsData(updatedWalletData);
        }
      }
    } catch (error) {}
  };

  const handleUpdateBanksList = (data) => {
    const updatedBanks = [...(data?.data?.banks ?? null)];
    const updatedWallet = [...(data?.data?.wallets ?? null)];
    setWalletsData([...updatedBanks, ...updatedWallet, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(updatedBanks?.[0]);
  };

  const handleSelectPaymentMethod = (value) => {
    let matchedObject = walletsData?.find((item) => item.id === value);
    let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    setWalletsData([matchedObject, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(matchedObject);
    setIsEditPayment(false);
  };

  const handleAddBank = (value) => {
    if (!value?.data) return;
    let updatedWallet = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Wallet');
    let updatedBank = walletsData?.filter((item) => item.id !== value && item.sourceType === 'Bank');
    setWalletsData([value.data, ...updatedWallet, ...updatedBank, { id: -1, brandName: 'Add new', sourceType: 'add new' }]);
    setSelectedPaymentMethod(value.data);
    setIsEditPayment(false);
  };

  const openTOSAgreementModal = () => {
    setIsTOSModal(true);
  };

  const onTOSAgreementSuccess = () => {
    setIsTOSModal(false);
    onPinVerifySuccess();
  };

  const onTOSModalClose = () => {
    setIsTOSModal(false);
  };

  const onPinVerifySuccess = () => {
    walletsData.length <= 0 && handleFeatchBankDetail();
    handleGetAccountBalances();
    modalState('StepTwo');
    setPin('');
    setIsTurmAndCondistion(false);
    setCheckbox1(false);
    setCheckbox2(false);
    setNumberOfShare(
      remainingShares < Number(quickBuyPropertyData?.minimum) / Number(quickBuyPropertyData?.perSharePrice)
        ? Math.floor(
            ((Number(quickBuyPropertyData?.totalShares) * 9.8) / 100 - Number(quickBuyPropertyData?.userPurchasedShares)).toFixed(2)
          ).toString()
        : Math.ceil(getUsCurrencyFormat(quickBuyPropertyData?.minimum / quickBuyPropertyData?.perSharePrice).toString())
    );
    // props.clickAction
  };

  const handleVerifyPin = async (isTOSAccepted = false) => {
    if (!isTOSAccepted) {
      modalState('');
      toastNotify(
        'newAgreement',
        <ListingAgreementNotification
          onBtnClick={() => {
            notification.close('newAgreement');
            openTOSAgreementModal();
          }}
        />
      );
    } else {
      onPinVerifySuccess();
    }
  };

  const handleForgotPin = async () => {
    setLoading(true);
    try {
      const resData = await resetLoginPin();
      if (!resData.isError) {
        toastNotify('success', resData?.message);
        modalState();
        setResetPin(true);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePlaceOrder = async () => {
    if (
      selectedPaymentMethod?.sourceType === 'Wallet' &&
      (Number(Number(quickBuyPropertyData?.perSharePrice) * Number(numberOfShare)) > Number(userBalance?.cash) || userBalance === 0)
    ) {
      const linkText = 'My Account>Account Balances';
      const linkPath = '/account/transactions';
      const openLink = () => {
        window.location.href = linkPath;
      };
      notification.error({
        description: (
          <div>
            <span style={{ cursor: 'pointer' }} onClick={openLink}>
              Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
            </span>
          </div>
        ),
        duration: 5,
      });
    } else {
      setLoading(true);
      let data = {
        fundingSourceId: selectedPaymentMethod?.id?.toString(),
        propertyId: quickBuyPropertyData?.id?.toString(),
        noOfShares: parseInt(numberOfShare),
      };
      try {
        const resData = await placeBuyOrder(data);
        if (!resData.isError) {
          setOrderId(resData?.data?.id);
          handleFeatchAgreement(resData?.data?.id);
        }
      } catch (error) {
        setLoading(false);
        const { response } = error;
        toastNotify('error', response?.data?.message);
      }
    }
  };

  const handleFeatchAgreement = async (id) => {
    setLoading(true);
    try {
      const resData = await getAgreement(id);
      if (!resData.isError) {
        setAgreementData(resData);
        modalState('StepFour');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAgreeAndContinue = async () => {
    setLoading(true);
    try {
      const resData = await processPlaceOrder(orderId);
      if (!resData.isError) {
        modalState('success');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const featchInitialOfferingData = async () => {
    let response = await dispatch(fetchInitialOfferingListAction({ page: 1, perPage: 10 }));
    if (!response?.payload?.isError) {
      modalState();
    }
  };

  const featchSecondaryOfferingData = async () => {
    await dispatch(fetchSecondaryOfferingListAction({ page: 1, perPage: 9 }));
  };

  const handleCancelBuyOrder = async () => {
    await dispatch(cancelBuyOrderAction({ id: orderId }));
  };

  return {
    loading,
    pin,
    walletsData,
    agreementData,
    totalInvestment,
    totalPurchase,
    equity,
    isScrolledBuy,
    numberOfShare,
    resetPin,
    checkbox1,
    checkbox2,
    daysReamaining,
    isTurmAndCondistion,
    isMaxRangeError,
    isMinRangeError,
    sharesRemainingToPurchase: remainingShares,
    selectedPaymentMethod,
    isEditPayment,
    minButtonValue,
    handleVerifyPin,
    handleForgotPin,
    handlePlaceOrder,
    handleScrollBuy,
    handleAgreeAndContinue,
    setNumberOfShare,
    setResetPin,
    setCheckbox1,
    setCheckbox2,
    setPin,
    setIsTurmAndCondistion,
    handleSelectPaymentMethod,
    handleUpdateBanksList,
    setIsEditPayment,
    handleAddBank,
    featchInitialOfferingData,
    handleCancelBuyOrder,
    featchSecondaryOfferingData,
    setLoading,
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
  };
};

export default useQuickBuyOrder;
